export default __webpack_public_path__ + "static/media/account.45ec310e.svg";